export interface LogoProps {
  className?: string;
}

export function Logo({ className = "max-h-16 min-h-12 min-w-16 object-scale-down" }: LogoProps) {
  return (
    <a href="/">
      <img
        className={className}
        src="/evtcc-logo.png"
        alt="EVTCC Logo"
      />
    </a>
  );
}